export const FilterLogic = {
    and: "and",
    or: "or",
} as const;
export type FilterLogicType = (typeof FilterLogic)[keyof typeof FilterLogic];

export const FilterOperator = {
    equals: "equals",
    contains: "contains",
    notEquals: "notEquals",
    notContains: "notContains",
    empty: "empty",
    notEmpty: "notEmpty",
} as const;
export type FilterOperatorType = (typeof FilterOperator)[keyof typeof FilterOperator];

export interface ILegalListFilterRow {
    field: string;
    operator: FilterOperatorType;
    value: string;
}

export interface ILegalListFilter {
    logic: FilterLogicType;
    rows: ILegalListFilterRow[];
}

export const defaultListFilter: ILegalListFilter = {
    logic: FilterLogic.and,
    rows: [{ field: "ya_name", operator: FilterOperator.contains, value: "" }],
};

export const defaultBankDetailsFilter: ILegalListFilter = {
    logic: FilterLogic.and,
    rows: [{ field: "ya_account_currency", operator: FilterOperator.contains, value: "" }],
};
